import { initialize } from "launchdarkly-js-client-sdk"
import { useEffect, useState } from "react"

const anonymousUserContext = {
    kind: "user",
    key: "anonymous",
    anonymous: true,
    platform: "web",
}

const featureFlagsClient = initialize(window.ld_client_id, anonymousUserContext, {
    sendEventsOnlyForVariation: true,
})
Object.freeze(featureFlagsClient)

let ready = false
featureFlagsClient.on("ready", () => {
    ready = true
})

export const featureFlagsClientIsReady = (): boolean => ready

export const useFeatureFlagsClientIsReady = (): boolean => {
    const [isReady, setIsReady] = useState(false)
    useEffect(() => {
        if (featureFlagsClientIsReady()) {
            setIsReady(true)
            return
        }
        // The "ready" event will always be emitted by the client, whether it successfully initialized or not.
        // If the client did not initialize successfully, it will serve default feature flag values.
        featureFlagsClient.on("ready", () => {
            setIsReady(true)
        })
    }, [])
    return isReady
}

export default featureFlagsClient
